import { useMutation } from 'react-query';
import { api } from 'services/api';
import Cookies from 'js-cookie';
import { GET_IN_AUTH_TOKEN_COOKIE_KEY } from 'utils/constants';
import { getUser } from 'hooks/use-login';

interface UserProps {
  name: string;
  social_name: string;
  email: string;
  birthday: string;
  gender: string;
}

type UseRegisterParams = {
  currentFlow: 'sms' | 'email';
  params: {
    session: string;
    user: UserProps;
  };
};

export type RegisterResponse = {
  session: string;
  event: string;
  email: string;
  access_token: string;
};

type RegisterProps = {
  status: number;
  data: RegisterResponse;
};

export const register = async (
  data: UseRegisterParams
): Promise<RegisterProps> => {
  const { params, currentFlow } = data;
  const { user } = params;

  const paramsFiltred = Object.keys(user).forEach((key) => {
    if (user[key as keyof UserProps] === '') {
      delete user[key as keyof UserProps];
    }
  });

  const { status, data: response } = await api.post(
    `/auth/v3/${currentFlow}/user`,
    {
      ...params,
      paramsFiltred,
    }
  );

  if (status === 200) {
    if (response.data.access_token) {
      Cookies.set(GET_IN_AUTH_TOKEN_COOKIE_KEY, response.data.access_token);
      await getUser();
    }
  }

  return {
    status,
    data: {
      ...response.data,
    },
  };
};

export const useRegister = () => {
  return useMutation('register', (data: UseRegisterParams) => register(data));
};
